import _useDeleteMatterMutation from "./__generated__/useDeleteMatterMutation.graphql";
import { newId, useMutation, graphql } from "@workflows/runtime-web";
import { useViewerTenant } from "@workflows/ui";
import { useDeleteMatterMutation, useDeleteMatterMutation$data } from "./__generated__/useDeleteMatterMutation.graphql";
interface useDeleteMatterProps {
  onError?: (error: Error) => void;
  onCompleted?: (data: useDeleteMatterMutation$data) => void;
  input: {
    matterId: string;
  };
}
interface useDeleteMatterValue {
  deleteMatter: (props: useDeleteMatterProps) => void;
  isPending: boolean;
}
export const useDeleteMatter = (): useDeleteMatterValue => {
  const {
    tenantId
  } = useViewerTenant(true);
  const [mutation, isPending] = useMutation<useDeleteMatterMutation>(deleteMatterMutation);
  const deleteMatter = (props: useDeleteMatterProps) => {
    const {
      input: {
        matterId
      },
      ...rest // you can still provide onError and onComplete
    } = props;
    mutation({
      variables: {
        input: {
          tenantId,
          matterId,
          clientMutationId: newId()
        }
      },
      onError(error) {
        console.error(error);
        rest?.onError?.(error);
      },
      onCompleted(data) {
        if (data._deleteMatter?.errors && data._deleteMatter?.errors.length > 0) {
          console.error(data._deleteMatter.errors);
        }
        rest?.onCompleted?.(data);
      }
    });
  };
  return {
    deleteMatter,
    isPending
  };
};
const deleteMatterMutation = (_useDeleteMatterMutation.hash && _useDeleteMatterMutation.hash !== "c5ee25dddb470b6ffe6d9bdeb1e5719e" && console.error("The definition of 'useDeleteMatterMutation' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _useDeleteMatterMutation);